import { getPatient } from './../../../graphql/queries';
import { GetPatientQuery } from '@/API';
import { useEffect, useState } from 'react';
import awsconfig from '@/amplifyconfiguration.json';
import { fetchAuthSession } from 'aws-amplify/auth';
import { Amplify } from 'aws-amplify';
import { executeQuery } from '@/client/graphql';

Amplify.configure(awsconfig);

export const useGetPatient = () => {
  const [patient, setPatient] = useState<GetPatientQuery | undefined>();
  const [loading, setLoading] = useState<boolean>(true);

  const loadPatientData = async () => {
    const session = await fetchAuthSession();
    const cognitoid = session.userSub as string;
    const result = await executeQuery<GetPatientQuery>(getPatient, { id: cognitoid }, 'userPool');
    setPatient(result);
    setLoading(false);
  };

  useEffect(() => {
    loadPatientData();
  }, []);

  return {
    patient,
    loading
  };
};
